exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .executeTestCasesForm_execution_select_dropdown__1YezZ{margin-bottom:2.4rem}.executeTestCasesForm_checkedBox__2Z0O2{color:red}[dir] .executeTestCasesForm_checkedBox__2Z0O2{margin-top:2rem}", ""]);

// Exports
exports.locals = {
	"execution_select_dropdown": "executeTestCasesForm_execution_select_dropdown__1YezZ",
	"checkedBox": "executeTestCasesForm_checkedBox__2Z0O2"
};